exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sidebar-ai[data-v-9d667516]{display:flex;justify-content:center;align-items:center;padding:6px 0;background:#ffffff;box-shadow:-6px 0px 8px -4px rgba(0,0,0,0.12);border-radius:4px 0px 0px 0px}.sidebar-ai-icon[data-v-9d667516]{width:16px;height:16px}\n", ""]);

